export const GAP_THRESHOLDS = {
  HIGH: 50,
  MODERATE: 20,
  LOW: 0,
}

export type GapCategory = 'High' | 'Moderate' | 'Low' | 'Negative'

export function getGapCategory(gap: number): GapCategory {
  if (gap > GAP_THRESHOLDS.HIGH) return 'High'
  if (gap > GAP_THRESHOLDS.MODERATE) return 'Moderate'
  if (gap >= GAP_THRESHOLDS.LOW) return 'Low'
  return 'Negative'
}
